import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FormatUtils from 'utils/format';

const Price = ({className, amount, currencyType, showCents}) => {
    const classes = classNames('Price', className);
    const currencySymbol = FormatUtils.currencySymbol(currencyType);
    const {dollars, cents} = FormatUtils.price(amount);
    const displayCents = showCents && !cents ? '00' : cents;

    return (
        <span className={classes}>
            {currencySymbol}
            {dollars}
            {displayCents ? <sup>.{displayCents}</sup> : ''}
        </span>
    );
};

Price.propTypes = {
    className: PropTypes.string,
    amount: PropTypes.number.isRequired,
    currencyType: PropTypes.string,
    showCents: PropTypes.bool,
};

export default Price;
